import React from 'react';
import { Route } from 'react-router-dom';
import { newTourImage, editTourImage, showTourImage } from '~/config/routes';
import List from './List';
import New from './New';
import Edit from './Edit';
import Show from './Show';
import { TourImageProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function TourImage() {
  return (
    <TourImageProvider>
      <>
        <Route
          exact
          path={newTourImage.spec}
          render={(props) => (
            <>
              <Can I="new" a="TourImages">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="TourImages">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editTourImage.spec}
          render={(props) => (
            <>
              <Can I="edit" a="TourImages">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="TourImages">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showTourImage.spec}
          render={(props) => (
            <>
              <Can I="show" a="TourImages">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="TourImages">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />

        <Route
          render={(props) => (
            <>
              <Can I="list" a="TourImages">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="TourImages">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </>
    </TourImageProvider>
  );
}
export default TourImage;
